<script setup>
// Preferência POR USUÁRIO: bolinha flutuante do Copiloto
// (uiSettings.show_copilot_launcher; default = mostrar).
// Toggle de discador webphone legado removido no cutover StackZap.
import { computed } from 'vue';
import { useUISettings } from 'dashboard/composables/useUISettings';
import { useMapGetter } from 'dashboard/composables/store';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import ToggleSwitch from 'dashboard/components-next/switch/Switch.vue';

const { uiSettings, updateUISettings } = useUISettings();
const currentAccountId = useMapGetter('getCurrentAccountId');
const isFeatureEnabledonAccount = useMapGetter(
  'accounts/isFeatureEnabledonAccount'
);

const captainEnabled = computed(() =>
  isFeatureEnabledonAccount.value(currentAccountId.value, FEATURE_FLAGS.CAPTAIN)
);

const showCopilot = computed(
  () => uiSettings.value?.show_copilot_launcher !== false
);

const setCopilot = value => updateUISettings({ show_copilot_launcher: value });
</script>

<template>
  <div class="flex flex-col w-full gap-1">
    <div
      v-if="captainEnabled"
      class="flex items-center justify-between gap-4 py-2"
    >
      <div class="flex flex-col">
        <span class="text-sm text-n-slate-12">Copiloto (bolinha de IA)</span>
        <span class="text-xs text-n-slate-11">
          Esconde o atalho flutuante do Copiloto. Você ainda abre o Copiloto
          dentro da conversa.
        </span>
      </div>
      <ToggleSwitch
        :model-value="showCopilot"
        @update:model-value="setCopilot"
      />
    </div>
  </div>
</template>
